import { IRootState } from '../../../store'
import { ICardioOptionsState } from '../store/options.types'

export const getInitialAssessmentCardioOptionsSelector = (state: IRootState): ICardioOptionsState =>
  state.options.cardioOptions
